import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusFilter'
})
export class StatusFilterPipe implements PipeTransform {
    transform(item: any): boolean {
    
        return item && item.status === 'Open';
    }
}


// WEBPACK FOOTER //
// ./src/pipes/status/status.ts